import {ChipProps} from '@mui/material/Chip';
import {AdminBatchJob, AdminBatchJobStatus, AdminBatchJobType, AdminBatchSubmissionStatus} from '../types/adminBatch.ts';
import { formatKstDateTime } from './dateTime';

export const batchJobStatusColor = (status: AdminBatchJobStatus): ChipProps['color'] => {
    if (status === 'SUCCEEDED') return 'success';
    if (status === 'FAILED') return 'error';
    if (status === 'CANCELED') return 'default';
    if (status === 'AWAITING_RESULTS') return 'info';
    return 'warning';
};

export const batchJobStatusLabel = (status: AdminBatchJobStatus): string => {
    if (status === 'PENDING') return '대기';
    if (status === 'RUNNING') return '진행중';
    if (status === 'AWAITING_RESULTS') return '결과대기';
    if (status === 'SUCCEEDED') return '완료';
    if (status === 'FAILED') return '실패';
    return '중단';
};

export const batchSubmissionStatusLabel = (status: AdminBatchSubmissionStatus): string => {
    if (status === 'SUBMITTED') return '요청됨';
    if (status === 'COMPLETED') return '완료';
    return '실패';
};

export const batchSubmissionStatusColor = (status: AdminBatchSubmissionStatus): ChipProps['color'] => {
    if (status === 'COMPLETED') return 'success';
    if (status === 'FAILED') return 'error';
    return 'warning';
};

export const batchJobTypeLabel = (jobType: AdminBatchJobType): string => {
    if (jobType === 'DICTIONARY_METADATA_BACKFILL') return '사전 메타데이터 백필';
    if (jobType === 'CONTENT_QUALITY_ANALYSIS') return '콘텐츠 품질 분석';
    if (jobType === 'CONTENT_QUALITY_APPLY') return '콘텐츠 품질 보정';
    if (jobType === 'WORDBOOK_MAGIC_CARD_GENERATION') return '단어장 매직카드 생성';
    if (jobType === 'LIBRARY_THUMBNAIL_GENERATION') return '라이브러리 썸네일 생성';
    if (jobType === 'AI_IMAGE_GENERATION') return 'AI 이미지 생성';
    return jobType;
};

export const batchScopeLabel = (job: AdminBatchJob): string => {
    if (job.scopeType === 'GLOBAL') return '전체 범위';
    if (job.scopeType === 'WORDBOOK') return `단어장 #${job.scopeId ?? '-'}`;
    if (job.scopeType === 'LIBRARY') return `라이브러리 #${job.scopeId ?? '-'}`;
    if (job.scopeType === 'AI_IMAGE_REQUEST') return `AI 이미지 요청 #${job.scopeId ?? '-'}`;
    if (job.scopeType === 'EXAM_TYPE') return `시험 유형 #${job.scopeId ?? '-'} (구)`; // 제거된 도메인 — 과거 잡 표시용
    return `${job.scopeType} #${job.scopeId ?? '-'}`;
};

export const formatBatchDateTime = (value?: string) => {
    return formatKstDateTime(value);
};
